import React from 'react'
import {
  Table,
  Button
} from "reactstrap";
function ProductList({certificatedProducts, fetchProductRelateCertificationDetails}) {
  return (
    <div className=''>
       <Table striped >
            <thead>
              <tr>
                <th>S.No.</th>
                <th>Name</th>
                <th>Part No</th>
                <th>Certifications</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {certificatedProducts?.map((item, index) => (
                <tr key={index}>
                  <td >{index + 1}</td>
                  <td >{item.name}</td>
                  <td >{item.part_number}</td>
                  <td>
                    <ul className='list-unstyled certificationList'>
                      {item.certifications?.map((certification)=>(
                        <li className='m-1'>{certification.name.toUpperCase()}</li>
                      ))}
                    </ul>
                  </td>
                  <td >
                    <Button color="success" type="button" onClick={() => fetchProductRelateCertificationDetails(item.id)}>
                      Change Date Validity
                    </Button>
                  </td>
                  
                </tr>
              ))}
            </tbody>
       </Table>
    </div>
  )
}

export default ProductList
